import { Label, Input, InputType } from '@gcl/react-core';
import * as React from 'react';
import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect';
import { StringFilter, IFilterInputBaseProps } from '../searchFilter.models';
import { getFilterValue } from '../searchFilter.services';
import './StringFilterInput.scss';

export interface IStringFilterInputProps extends IFilterInputBaseProps<StringFilter> {}

export const StringFilterInput: React.FunctionComponent<IStringFilterInputProps> = ({
  fieldConfig,
  onChange,
  filter = {},
  disabled = false,
}) => {
  const [localValue, setLocalValue] = React.useState<string | undefined>(undefined);
  const { fieldName, displayName, disable } = fieldConfig;

  useDeepCompareEffectNoCheck(() => {
    const value = getFilterValue(fieldName, filter);

    setLocalValue(value ? value.toString() : undefined);
  }, [JSON.stringify(filter)]);

  return (
    <>
      <Label labelFor={fieldName}>{displayName}</Label>
      <Input
        id={`${fieldName}`}
        type={InputType.Text}
        disabled={disabled || disable}
        value={localValue}
        className="gcl-gems-string-filter-input"
        shouldDebounce
        onChange={(newValue) => {
          onChange(fieldName, newValue ? newValue.toString() : undefined);
        }}
      />
    </>
  );
};
